// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import DataKeeper from "../views/DataKeeper/DataKeeper";
import Tools from "../views/Tools/Tools";
import Configurations from "../views/Configurations/Configurations";

const dashboardRoutes = [
  {
    path: "/data-manager",
    name: "Module Manager",
    icon: "pe-7s-albums",
    component: DataKeeper,
  },
  {
    path: "/tools",
    name: "Tools",
    icon: "pe-7s-tools",
    component: Tools,
  },
  {
    path: "/configurations",
    name: "Configurations",
    icon: "pe-7s-config",
    component: Configurations,
  },
  { redirect: true, path: "/", to: "/data-manager", name: "Module Manager" },
];

export default dashboardRoutes;
